'use client';

import { AnimatePresence, motion } from 'motion/react';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import BlogListingCard from './BlogListingCard';

const stagger = {
  animate: {
    transition: {
      staggerChildren: 0.03, // Reduced stagger delay
    },
  },
} as const;

export const ClientTagListing = ({ filteredResults }: { filteredResults: any }) => {
  const [displayedItemsCount, setDisplayedItemsCount] = useState(6);
  const { ref, inView } = useInView({
    threshold: 0.05,
    triggerOnce: false,
  });

  useEffect(() => {
    if (inView && displayedItemsCount < filteredResults.length) {
      setDisplayedItemsCount(prev => Math.min(prev + 3, filteredResults.length));
    }
  }, [inView, filteredResults.length, displayedItemsCount]);

  return (
    <section className="container py-20">
      {filteredResults.length > 0 ? (
        <>
          <motion.article
            className="grid grid-cols-12 gap-x-8 gap-y-20 sm:gap-x-0 sm:gap-y-15"
            variants={stagger}
            initial="initial"
            animate="animate"
          >
            <AnimatePresence>
              {filteredResults.slice(0, displayedItemsCount).map((card: any, index: number) => (
                <BlogListingCard key={`${card.sys.id}-${index}`} card={card} initiallyVisible={index < 3} />
              ))}
            </AnimatePresence>
          </motion.article>
          {displayedItemsCount < filteredResults.length && <div ref={ref} className="col-span-full h-20" />}
        </>
      ) : (
        <p className="text-Body text-center">No blogs with this tag found 🫥</p>
      )}
    </section>
  );
};
